import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Fluxible } from 'fluxible';
import { FluxibleComponent, connectToStores } from 'fluxible-addons-react';
import OnlineStatusStore from 'stores/OnlineStatusStore';
import OnlineStatusActionCreators from 'actions/OnlineStatusActionCreators';
import StatusIndicator from 'components/StatusIndicator';

export default (node) => {
    const lastSeenTimesUrl = node.getAttribute('data-last-seen-times-url');
    const intlData = JSON.parse(node.getAttribute('data-last-seen-indicator-translation-map'));
    const dataProfileUser = JSON.parse(node.getAttribute('data-profile-user'));

    const app = new Fluxible({ stores: [OnlineStatusStore] });
    const context = app.createContext();

    const ConnectedStatusIndicator = connectToStores(
        StatusIndicator,
        [OnlineStatusStore],
        (ctx, props) => {
            const store = ctx.getStore(OnlineStatusStore);
            return {
                isOnline: store.getOnlineStatus(props.user.id),
                lastSeenTime: store.getLastSeenTime(props.user.id),
            };
        },
    );

    window.setInterval(() => {
        if (document.hasFocus()) {
            context.executeAction(OnlineStatusActionCreators.getOnlineStatus, { lastSeenTimesUrl });
        }
    }, 60000);

    window.addEventListener('focus', () => {
        context.executeAction(OnlineStatusActionCreators.getOnlineStatus, { lastSeenTimesUrl });
    });

    context.executeAction(OnlineStatusActionCreators.getOnlineStatus, { lastSeenTimesUrl });

    ReactDOM.render(
        (
            <IntlProvider locale={intlData.locale} messages={intlData.messages}>
                <FluxibleComponent context={context.getComponentContext()}>
                    <ConnectedStatusIndicator user={dataProfileUser} />
                </FluxibleComponent>
            </IntlProvider>
        ), node,
    );
};



// WEBPACK FOOTER //
// ./src/js/apps/online-status/initIndicator.jsx